namespace $.$$ {
	let instance = 0
	export class $shm_hotkey extends $.$shm_hotkey {
		private readonly anchor_prefix = `--shm-hotkey-${ ++instance }-`
		private readonly anchors = new Map< string, string >()
		private held = false
		private release_pending = false
		private focus_before: HTMLElement | null = null
		@ $mol_mem target_id( next = '' ) { return next }
		@ $mol_mem configuring( next = false ) { return next }
		@ $mol_mem status( next = '' ) { return next }
		activation_label() { return this.Model().activation().replace( /^Key|^Digit/, '' ) }
		editor_message() { return this.configuring() ? 'Нажмите новую клавишу назначения' : 'Нажмите клавишу или сочетание. Escape — отмена.' }
		remove_enabled() { return Boolean( this.Model().bindings()[ this.target_id() ] ) }
		@ $mol_mem supported() {
			const css = this.$.$mol_dom_context.CSS
			return !!css?.supports( 'anchor-name', '--hotkey' ) && ( css.supports( 'position-visibility', 'anchors-visible' ) || css.supports( 'position-visibility', 'anchor-visible' ) )
		}
		@ $mol_mem ids() { return Object.keys( this.Model().bindings() ) }
		anchor_name( id: string ) {
			if( !this.anchors.has( id ) ) this.anchors.set( id, this.anchor_prefix + this.anchors.size )
			return this.anchors.get( id )!
		}
		editor_anchor() { return this.anchor_name( this.target_id() ) }
		mark_label( id: string ) { return $shm_hotkey_label( this.Model().bindings()[ id ] ) }
		@ $mol_mem rules() {
			if( !this.supported() ) return ''
			const root = this.root() as HTMLElement | null
			if( !root?.id ) return ''
			const escape = this.$.$mol_dom_context.CSS.escape
			const ids = new Set([ ... this.ids(), ... this.target_id() ? [ this.target_id() ] : [] ])
			return [ ... ids ].map( id => `#${ escape( root.id ) } #${ escape( id ) } { anchor-name: ${ this.anchor_name( id ) }; }` ).join( '\n' )
		}
		layers() { return this.supported() ? [ this.Style(), ... this.ids().map( id => this.Mark( id ) ), this.Editor() ] : [] }
		@ $mol_mem listeners() {
			const root = this.root() as HTMLElement | null
			if( !root || !this.supported() ) return null
			const doc = root.ownerDocument, win = doc.defaultView!
			const callbacks: [ EventTarget, string, ( event: any )=> void ][] = [
				[ doc, 'keydown', event => this.keydown( event ) ],
				[ doc, 'keyup', event => this.keyup( event ) ],
				[ doc, 'click', event => this.click_capture( event ) ],
				[ doc, 'pointerdown', event => { if( this.held && !event.button && this.inside( event ) && this.control( event ) && !this.dom_node().contains( event.target ) ) this.consume( event ) } ],
				[ win, 'blur', event => { if( event.target === win ) this.reset() } ],
			]
			for( const [ host, name, callback ] of callbacks ) host.addEventListener( name, callback, true )
			return { destructor: ()=> { for( const [ host, name, callback ] of callbacks ) host.removeEventListener( name, callback, true ) } }
		}
		inside( event: Event ) {
			const root = this.root() as HTMLElement | null
			return !!root?.isConnected && ( root.contains( event.target as Node ) || event.target === root.ownerDocument.body )
		}
		editable( event: Event ) {
			return event.composedPath().some( node => node instanceof this.$.$mol_dom_context.HTMLElement && ( node.isContentEditable || node.matches( 'input,textarea,select,[role="textbox"]' ) ) )
		}
		consume( event: Event ) { event.preventDefault(); event.stopImmediatePropagation() }
		control( event: Event ) {
			return event.composedPath().find( node => node instanceof this.$.$mol_dom_context.HTMLElement && node.matches( 'button,a[href],[role="button"],[role="checkbox"],[role="switch"],input[type="button"],input[type="submit"]' ) ) as HTMLElement | undefined
		}
		available( target: HTMLElement ) {
			if( target.closest( '[inert],[aria-disabled="true"],[disabled],[hidden]' ) || !target.checkVisibility({ checkVisibilityCSS: true, checkOpacity: true }) ) return false
			// Only the one matched target is measured, never all controls or on scroll.
			// Hit-testing also excludes clipped controls and controls under a modal.
			const box = target.getBoundingClientRect(), doc = target.ownerDocument, win = doc.defaultView!
			const left = Math.max( 0, box.left ), right = Math.min( win.innerWidth, box.right )
			const top = Math.max( 0, box.top ), bottom = Math.min( win.innerHeight, box.bottom )
			if( left >= right || top >= bottom ) return false
			const hit = doc.elementFromPoint( ( left + right ) / 2, ( top + bottom ) / 2 )
			return !!hit && target.contains( hit )
		}
		@ $mol_action keydown( event: KeyboardEvent ) {
			if( !this.inside( event ) || event.isComposing || event.getModifierState( 'AltGraph' ) ) return
			if( this.Editor().showed() ) {
				if( event.code === 'Escape' ) { this.consume( event ); this.close(); return }
				if( event.code === 'Delete' && !this.configuring() && !event.ctrlKey && !event.altKey && !event.shiftKey && !event.metaKey ) { this.consume( event ); this.remove( event ); return }
				if( this.release_pending || event.repeat || event.code === 'Tab' ) return
				const key = $shm_hotkey_binding_from( event )
				if( !key ) return
				this.consume( event )
				if( this.configuring() ) {
					if( key.ctrl || key.alt || key.shift || key.meta ) { this.status( 'Выберите одну клавишу без модификаторов.' ); return }
					if( this.Model().index().has( $shm_hotkey_chord( key ) ) ) { this.status( 'Эта клавиша уже назначена кнопке.' ); return }
					this.Model().activation( key.code ); this.configuring( false ); this.status( '' ); return
				}
				const error = this.Model().assign( this.target_id(), key )
				if( error ) this.status( error )
				else this.close()
				return
			}
			if( event.defaultPrevented || this.editable( event ) ) return
			if( event.code === this.Model().activation() && !event.ctrlKey && !event.altKey && !event.metaKey && !event.shiftKey ) {
				this.held = true; this.consume( event ); return
			}
			if( event.repeat ) return
			const key = $shm_hotkey_binding_from( event )
			const id = key && this.Model().index().get( $shm_hotkey_chord( key ) )
			if( !id ) return
			const target = ( this.root() as HTMLElement ).ownerDocument.getElementById( id )
			if( !target || !( this.root() as HTMLElement ).contains( target ) || !this.available( target ) ) return
			this.consume( event ); target.click()
		}
		keyup( event: KeyboardEvent ) {
			if( event.code === this.Model().activation() ) { this.held = false; this.release_pending = false }
		}
		@ $mol_action click_capture( event: MouseEvent ) {
			if( !this.held || event.button || !this.inside( event ) || this.dom_node().contains( event.target as Node ) ) return
			const target = this.control( event )
			if( !target?.id || target.closest( '[inert],[aria-disabled="true"],[disabled]' ) ) return
			this.consume( event )
			this.focus_before = target
			this.target_id( target.id ); this.status( '' ); this.configuring( false ); this.release_pending = true
			this.Editor().showed( true )
			new this.$.$mol_after_tick( ()=> {
				const editor = this.Editor()
				if( !editor.showed() ) return
				editor.Bubble().focused( true )
				// Establish the pick's normal focus dependency after moving from
				// the external target into the popup. Outside focus still closes it.
				editor.showed( true )
			} )
		}
		@ $mol_action close() { this.Editor().showed( false ); this.configuring( false ); this.release_pending = false; this.focus_before?.focus({ preventScroll: true }) }
		@ $mol_action reset() { this.held = false; this.release_pending = false; this.Editor().showed( false ) }
		@ $mol_action remove( event?: Event ) { if( event ) { this.Model().remove( this.target_id() ); this.close() }; return event ?? null }
		@ $mol_action configure( event?: Event ) { if( event ) { this.configuring( true ); this.status( '' ) }; return event ?? null }
	}
}
